import { render, staticRenderFns } from "./Head-logo.vue?vue&type=template&id=6864f00e&scoped=true";
import script from "./Head-logo.vue?vue&type=script&lang=js";
export * from "./Head-logo.vue?vue&type=script&lang=js";
import style0 from "./Head-logo.vue?vue&type=style&index=0&id=6864f00e&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "6864f00e", null);
export default component.exports;